export default {
  loginMessage: {
    succeeded: 'Login success.',
    failed: 'Logout.'
  },
  header: {
    portfolios: 'Portfolios',
    competitions: 'Competitions',
    bhuntr: 'BountyHunter',
    services: 'Services',
    contest: 'Contest Builder',
    wantToContest: 'Are You Running a Contest?',
    organizers: 'Organizers',
    level: 'Level',
    exp: 'Exp',
    hunterArea: 'Hunter Area',
    myPortfolios: 'My Portfolio',
    myContests: 'My Contest',
    myOrders: 'My Order',
    settings: 'My Settings',
    logout: 'Log out',
    login: 'Log in',
    signup: 'Sign up',
    competition: {
      highlight: 'Highlight',
      wall: 'All Contest'
    },
    organizerDashboard: 'Organizer Dashboard',
    builderSupport: 'Builder Support'
  },
  contactUs: {
    name: 'Name',
    email: 'Email',
    phone: 'Phone number',
    content: 'Content',
    submit: 'Submit'
  },
  entry: {
    submissionDuring: 'Submission during',
    winnerAnnouncements: 'Winner Announcement',
    addToGoolgeCalendar: 'Add To Goolge Calendar',
    during: 'to',
    totalPrize: 'Total Prize',
    firstPrize: 'Highest Prize',
    subscribe: 'Subscribe',
    unsubscribe: 'Unsubscribe',
    share: 'Share',
    goToWebsite: 'Go To Contest',
    organizer: 'Organizer',
    subscriber: 'Subscribers',
    more: 'more',
    comments: 'Q & A',
    replyComment: 'Reply',
    similarCompetitions: 'Similar Competitions',
    noSubscriber: 'No subscriber.',
    subscribers: 'Subscribers ({total})',
    subscriberLevel: 'Lv.',
    follow: 'Follow',
    unfollow: 'Unfollow',
    savedBackToEntry: 'Back to competition',
    loginToContinue: 'Please log in first.',
    loadMoreComments: 'More comments',
    calendarSubmissionTitle: '{title} Submission Dateline',
    calendarWinnerAnnouncementTitle: '{title} Winner Announcement',
    calendarDescription: '{title} Website https://bhuntr.com/{locale}/competitions/{alias}',
    attachments: 'Attachments',
    contestIsEnded: 'This event has ended.',
    contestIsEndedTips: 'Go find other contests on our <a href="http://bhuntr.com/competitions/wall">Contest Wall</a>.'
  },
  comments: {
    username: 'Username',
    email: 'E-mail',
    submit: 'Submit'
  },
  search: {
    tagSearch: 'Tag Search'
  },
  competition: {
    highlight: 'Highlight',
    search: 'Search',
    category: 'Category',
    resetFilter: 'Reset',
    stage: 'Stage',
    sort: 'Sort by',
    location: 'Location',
    loading: 'Loading',
    notFound: 'Cannot find the competitions.',
    notFoundMessages: 'Oops! You can change the keyword and try again.',
    noMoreResults: 'Oops! No more results.',
    status: {
      all: 'All',
      cfp: 'Call for submission',
      voting: 'Voting',
      preordering: 'Preordering',
      winnerAnnouncement: 'Winner Announce',
      finished: 'Finish'
    },
    includeOldCompetitions: 'Within old',
    tools: 'Tools',
    totalItems: 'Total {totalItems} competitions',
    totalPrize: 'Total Prize: {totalPrize}',
    submissionEnd: 'Submission End: {submissionEnd}',
    saveButton: 'Save',
    unsaveButton: 'Unsave',
    submitNowButton: 'Submit Now',
    sortBy: {
      newest: 'Newest',
      expiring: 'Expiring',
      popular: 'Popular',
      highestPrize: 'Highest Prize',
      unpopular: 'Unpopular'
    },
    worldwide: {
      all: 'Worldwide',
      tw: 'Taiwan',
      jp: 'Japan',
      th: 'Thailand',
      en: 'International'
    },
    prizeRange: 'Prize range',
    prizeRanges: {
      none: 'All',
      underFiftyThousand: 'Under $1,500',
      oneHundredfiftyThousand: '$1,500 ~ 4,600',
      threeHundredThousand: '$4,600 ~ $9,200',
      sixHundredThousand: '$9,200 ~ $18,000',
      overSixHundredThousand: 'Over $18,000'
    },
    datelineRange: 'Submission Dateline',
    endDateline: 'End of this date',
    datelineRanges: {
      none: 'All',
      threedays: 'Within 3 days',
      oneweek: 'Within one week',
      onemonth: 'Within one month'
    },
    filterButton: 'Filter',
    goToWall: 'Go to all competitions <span class="glyphicon glyphicon-chevron-right"></span>'
  },
  users: {
    myContests: 'My Contests',
    myPortfolios: 'My Portfolios',
    participatedContests: 'Participated contests',
    savedContests: 'Saved contests',
    duringSubmission: 'Submission',
    duringVoting: 'Voting',
    winnerAnnouncement: 'Winner Announcement',
    contestFinished: 'Finished',
    submissionDateline: 'Submission',
    votingDateline: 'Voting',
    winnerAnnouncementDateline: 'Winner Announcement',
    requireCertification: 'Require Certification',
    saveButton: 'Save',
    unsaveButton: 'Unsave',
    submissionDetail: 'Detail',
    cloneToPortfolio: 'Clone to my portfolio',
    submissionDetailTitle: 'Submission Detail',
    cloneSubmissionSuccessed: 'Copy submission successfully, you can go to your portfolio to see your work.',
    cloneSubmissionFailed: 'Copy submission failed. Please try again later.',
    level: 'Lv.',
    exp: 'Exp.',
    settings: 'My Settings',
    account: 'Account',
    profile: 'Profile',
    defaultSettings: 'Account Detail',
    accountEmail: 'Account E-mail',
    emailVerified: 'E-mail account has been certified.',
    emailNotVerified: 'E-mail account has not been certified.',
    emailInvalid: 'E-mail format is incorrect.',
    emailVerifyMessage: 'This is your login account Email, if you modify this item, you must re-login.',
    accountStatus: 'Account Status',
    resendVerifyEmail: 'Resend account verify e-mail.',
    language: 'Language',
    timezone: 'Timezone',
    subscribeEDM: 'Subscribe EDM',
    save: 'Save',
    verifyEmailSlogan: 'There are more feature after you verify your e-mail.',
    verifyEmailMessage: 'Your account is Good. You can save, visit and add your portfolios, follwoing some one now. If you want to voting submission, you need to verify your email.',
    resetPassword: 'Reset Password',
    originalPassword: 'Original password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    oldPasswordIsEmpty: 'Please fill the old password.',
    newPasswordIsEmpty: 'Please fill the new password.',
    newPasswordAndConfirmIsNotTheSame: 'New password and confirm password must be the same.',
    baseProfile: 'Profile detail',
    nickname: 'Nickname',
    lastname: 'Last name',
    firstname: 'First name',
    birthday: 'Birthday',
    telephone: 'Telephone',
    hunterCategory: 'Cateogry',
    country: 'Country',
    location: 'Location',
    experience: 'Experience',
    website: 'Website',
    bio: 'Bio',
    gender: {
      label: 'Gender',
      man: 'Man',
      female: 'Female',
      none: 'Unknown'
    },
    nickanmeIsEmpty: 'Please fill your nickname.',
    lastnameIsEmpty: 'Please fill your last name.',
    firstnameIsEmpty: 'Please fill your first name.',
    modifyAvatar: 'Modify avatar',
    selectImages: 'Select Image',
    cancel: 'Cancel',
    close: 'Close',
    badges: 'Hunter Badges',
    badgeName: 'Name',
    badgeDescription: 'Description',
    moreBadgeIcon: 'More badges',
    avatarFileNotExists: 'Please upload an avatar image.',
    avatarFilesSaveFailed: 'Avatar save failed, please try again later.',
    avatarFileSizeTooLarge: 'File is too large.',
    avatarFileIsNotImage: 'Please use the image file.'
  },
  blog: {
    blog: 'Blog',
    submit: 'Call for article',
    submitReadme: 'If you have a question for all kinds of creative ideas and good with words or pictures recorded welcome to submit to us, please write to:',
    hot: 'Hot articles',
    categories: 'Category',
    title: 'Recommend',
    more: 'Read mote',
    publishedAt: 'Published at {date}',
    authorNewestPost: 'Newest posts',
    authorInformation: 'About author',
    totalPosts: 'Total {post} posts',
    notFound: 'Cannot find the entries.',
    notFoundMessages: 'Oops! You can change the keyword and try again.',
    search: 'Search',
    recommend: 'Recommends',
    sourceLinkFrom: 'This article is published with the authorization from an original article here:'
  },
  loginModal: {
    title: 'Login',
    quickLogin: 'Quick Login',
    accountLogin: 'Login with Account',
    facebookLogin: 'Login With Facebook',
    twitterLogin: 'Login With  Twitter',
    googleLogin: 'Login With  Google+',
    account: 'Account',
    accountPlaceholder: 'Please enter your account',
    passwordPlaceholder: 'Please enter your password',
    password: 'password',
    goSignup: 'Sign up',
    forgotPassword: 'Forgot Password?',
    forgotPasswordButton: 'Reset password',
    forgotPasswordAccount: 'Account (E-mail)',
    login: 'Login',
    loginFailed: 'The account or password is incorrect, please try again.'
  },
  resetPassword: {
    title: 'Reset password',
    account: 'Account',
    newPassword: 'New password',
    confirmPassword: 'New password again',
    oops: 'Oops!',
    errorMessage: 'Your link may be in error or has expired ... <br>Please re-confirm the link is correct or try ',
    succeeded: 'Succeeded!',
    succeededMessage: 'Your password has been modified successfully, please go to ',
    loginPage: 'login page',
    forgotPasswordSucceeded: 'We\'ve sent your password reset message to your mailbox. Please check your mailbox.',
    fillAccount: 'Please fill the account (E-mail).',
    accountError: 'Your account does not exists.',
    fillPassword: 'Please fill the password.',
    passwordNotTheSame: 'The password are not the same.'
  },
  organizer: {
    lastStep: 'Last step',
    organizerDetail: 'Company / Organizer Information',
    organizerContactDetail: 'Contact Information',
    organizerName: 'Name',
    organizerTax: 'TAX No.',
    organizerPhoneNumber: 'Phone number',
    organizerAddress: 'Address',
    organizerWebsite: 'Website',
    organizerContactName: 'Name',
    organizerContactDept: 'Department',
    organizerContactTitle: 'Job title',
    organizerContactPhoneNumber: 'Phone number',
    organizerContactEmail: 'E-mail',
    description: 'We need to collect those information in order to make sure all the events you created are creditable. This information will be published on the competition microsite you created.',
    bountyHunterContactMe: 'I wish to be contacted by a BountyHunter advisor.',
    submitButton: 'Submit!',
    selectImages: 'Select Image',
    error: {
      organizerName: 'Please fill the organizer name.',
      organizerTax: 'Please fill the organizer TAX number.',
      organizerPhoneNumber: 'Please fill the organizer phone number.',
      organizerAddress: 'Please fill the organizer address.',
      organizerWebsite: 'Please fill the organizer website.',
      organizerContactName: 'Please fill the contact name.',
      organizerContactDept: 'Please fill the contact department name.',
      organizerContactTitle: 'Please fill the contact job title.',
      organizerContactPhoneNumber: 'Please fill the contact phone number.',
      organizerContactEmail: 'Please fill the contact E-mail.',
      avatarFileNotExists: 'Please upload an avatar image.',
      avatarFilesSaveFailed: 'Avatar save failed, please try again later.',
      avatarFileSizeTooLarge: 'File is too large.',
      avatarFileIsNotImage: 'Please use the image file.'
    }
  },
  needLogin: 'Please log in.',
  closeButton: 'Close'
}



// WEBPACK FOOTER //
// ./src/locales/en.js